// src/Components/Skeleton.jsx
import React from 'react';
import PropTypes from 'prop-types';

const Skeleton = ({ className }) => (
  <div className={`animate-pulse bg-gray-300 ${className}`} />
);

Skeleton.propTypes = {
  className: PropTypes.string,
};

export default Skeleton;